export const DEFAULT_TITLE = 'TEDx USSH';
export const dummy = 'dummy';
